module.exports = __webpack_public_path__ + "8674913ca47c78d704ce7e9c905ede7f.woff";